import { useState } from 'react';

export default function Toggle({ options, onChange, value }) {
  if (options?.length !== 2) {
    throw new Error('toggle accepts only two options');
  }

  const [localSelected, setLocalSelected] = useState(0);

  const selected = value || localSelected;

  function handleClick(idx) {
    if (value != null) {
      onChange(idx);
    } else {
      setLocalSelected(idx);
    }
  }

  return (
    <div className="relative flex justify-between">
      <div className="absolute inset-0 flex border-2 rounded-full bg-gray-100 border-gray-300"></div>

      <button
        type="button"
        className={`flex flex-1 justify-center z-20 text-sm px-12 py-1.5 whitespace-nowrap font-extrabold ${
          selected === 0 ? 'text-white' : ''
        }`}
        onClick={() => handleClick(0)}
      >
        {options[0]}
      </button>
      <button
        type="button"
        className={`flex flex-1 justify-center z-20 text-sm px-12 py-1.5 whitespace-nowrap font-extrabold ${
          selected === 1 ? 'text-white' : ''
        }`}
        onClick={() => handleClick(1)}
      >
        {options[1]}
      </button>
      <div
        className={`absolute w-1/2 inset-y-0 bg-secondary rounded-full transition-transform ${
          selected === 0 ? '' : 'translate-x-full'
        }`}
      ></div>
    </div>
  );
}
